const stZA= {
    login: {
      title: 'Kena',
      sign_in_btn: 'Kena'
    },
    bar: {
        logout: 'E-tswa',
        languages: 'Dipuo',
        settings: 'Bula Ditlhophiso'
    },
    language: {
      name: 'Sesotho (Afrika Borwa)',
    },
    attributePage: {
        title: 'Diphetoho tsa Makgabane',
        viewChanges: 'Lekola Diphetoho',
        dateTime: 'Letsatsi',
        notificationType: 'Mofuta wa Tsebiso',
        notificationValue: 'Boleng ba Tsebiso',
        oldValue: 'Boleng ba Kgale',
        newValue: 'Boleng bo Botjha',
        accept: 'Amohela',
        reject: 'Hana',
    },
    Home: 'Lapeng',
    load: 'E etsa loudu ya pele...',
    Requested: "E kopilwe",
    Viewed: "E bonwe",
    Executing: "Ya sebetsa",
    Completed: "E Phethetsweng",
    Expired: "E felletswe ke nako",
    Cancelled: "E hlakotswe",
    Error: "Phoso",
    Rejected: "E hannwe",
    error: 'Ho na le phoso e etsahetseng; ka kopo, leka hape.',
    displayname: 'Lebitso le Bonwang',
    givenname: 'Lebitso',
    surname: 'Fane',
    email: 'Imeili',
    mail: 'Imeili',
    name: 'Lebitso',
    firstname: 'Lebitso',
    lastname: 'Fane',
    footer_copyright: 'Ditokelo tsohle di sireleditswe.'
  };
  
  export default stZA;
  